import { remove } from 'lodash';
import type { Action } from '../typings/reducers';

type Lead = { _id: string } & Record<string, unknown>;
type LeadsState = { all: Lead[] };

export default function (state: LeadsState = { all: [] }, action: Action): LeadsState {
  switch (action.type) {
    case 'SET_ALL_LEADS':
      return { ...state, all: action.payload };
    case 'REMOVE_LEAD':
      const removeArray = state.all.slice();
      remove(removeArray, (item) => item._id === action.payload);

      return {
        ...state,
        all: [...removeArray]
      };
    default:
      return state;
  }
}
